import { render, staticRenderFns } from "./gridGallery.vue?vue&type=template&id=9bf84dc4&scoped=true"
import script from "./gridGallery.vue?vue&type=script&lang=js"
export * from "./gridGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf84dc4",
  null
  
)

export default component.exports